export enum DatenquelleSpitzLight {
    REFERENZANLAGE = 'REFERENZANLAGE',
    WETTER_DL_ANLAGENBETREIBER = 'WETTER_DL_ANLAGENBETREIBER',
    WETTER_DL_NETZBETREIBER = 'WETTER_DL_NETZBETREIBER'
}

export class DatenquelleSpitzLightItem {

    public key: string;
    public description: string;

    constructor(key: string, description: string) {
        this.key = key;
        this.description = description;
    }

    public static getAll(): DatenquelleSpitzLightItem[] {
        return [
            new DatenquelleSpitzLightItem(DatenquelleSpitzLight.REFERENZANLAGE, 'Referenzanlage'),
            new DatenquelleSpitzLightItem(DatenquelleSpitzLight.WETTER_DL_ANLAGENBETREIBER, 'Wetterdienstleister Anlagenbetreiber'),
            new DatenquelleSpitzLightItem(DatenquelleSpitzLight.WETTER_DL_NETZBETREIBER, 'Wetterdienstleister Netzbetreiber'),
        ];
    }

}

